import React, { useState, useEffect } from 'react';
import i18n from '../i18n';

const languages = [
  { code: 'fr', label: 'FR' },
  { code: 'en', label: 'EN' },
];

const LanguageSwitcher: React.FC = () => {
  const [currentLang, setCurrentLang] = useState<string>(
    (i18n.language || 'fr').startsWith('en') ? 'en' : 'fr'
  );

  useEffect(() => {
    const handleChange = (lng: string) => {
      setCurrentLang(lng.startsWith('en') ? 'en' : 'fr');
    };
    i18n.on('languageChanged', handleChange);
    return () => {
      i18n.off('languageChanged', handleChange);
    };
  }, []);

  const toggleLanguage = () => {
    const newLang = currentLang === 'fr' ? 'en' : 'fr';
    i18n.changeLanguage(newLang);
  };

  return (
    <button
      onClick={toggleLanguage}
      className="flex items-center gap-0.5 px-2 py-1.5 rounded-lg text-[11.5px] font-medium text-text-tertiary hover:text-text-primary hover:bg-surface-3 transition-colors"
      aria-label={`Switch language to ${currentLang === 'fr' ? 'English' : 'Français'}`}
    >
      {languages.map((lang) => (
        <span
          key={lang.code}
          className={`px-1.5 py-0.5 rounded ${
            currentLang === lang.code
              ? 'bg-accent-500/15 text-accent-500 font-semibold'
              : 'text-text-quaternary'
          }`}
        >
          {lang.label}
        </span>
      ))}
    </button>
  );
};

export default LanguageSwitcher;
